import type { UserProfileInfoMap, UserProfileParam } from '../api/types';

export const buildUserProfileInfoMap = (
  params: UserProfileParam[] = []
): UserProfileInfoMap => {
  return params.reduce((acc, { paramId, paramValue }) => {
    acc[paramId] = paramValue;
    return acc;
  }, {} as UserProfileInfoMap);
};
